// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_t3-5";
export var filledCircle = "_t3-4";
export var historyEntry = "_t3-3";
export var messageSideLeft = "_t3-1";
export var messageSideRight = "_t3-2";
export var orderTrackingCarouselWrapper = "_t3-6";
export var orderTrackingInfoContainer = "_t3-0";